/**
 * @internal
 * Render queue mask type.
 */
export enum RenderQueueMaskType {
  No,
  Increment,
  Decrement
}
